var _ = require('lodash');
var ActionTypes = require('lore-utils').ActionTypes;
var PayloadStates = require('lore-utils').PayloadStates;
var payload = require('lore-utils').payload;
var payloadCollection = require('lore-utils').payloadCollection;

function generatePortsArray(data) {
  var portNumbers = [];
  for (var i = data.auxPortLow; i <= data.auxPortHigh; i++) {
    portNumbers.push(i);
  }
  return portNumbers;
}

module.exports = function test(server) {

  // Iterate over the schema provided by the server, and generate the array
  // of ports we need to ping
  var portNumbers = generatePortsArray(server.data);

  return function(dispatch) {
    var Port = lore.models.port;

    var ports = portNumbers.map(function(portNumber) {
      return new Port({
        id: portNumber
      });
    });

    function fetch(model) {
      model.fetch().then(function() {
        dispatch({
          type: ActionTypes.update('port'),
          payload: payload(model, PayloadStates.RESOLVED)
        });
      }).catch(function(response) {
        var error = response.data;

        if (response.status === 404) {
          dispatch({
            type: ActionTypes.update('port'),
            payload: _.merge(payload(model), {
              state: PayloadStates.NOT_FOUND,
              error: error
            })
          });
        } else {
          dispatch({
            type: ActionTypes.update('port'),
            payload: payload(model, PayloadStates.ERROR_FETCHING, error)
          });
        }
      });
    }

    ports.forEach(function(port, index) {
      setTimeout(function() {
        fetch(port);
      }, 40*(index+1));

      dispatch({
        type: ActionTypes.add('port'),
        payload: payload(port, PayloadStates.FETCHING)
      });
    });

    // Send back a collection of all ports
    var Collection = lore.collections.port;
    var collection = new Collection();
    collection.models = ports;

    var combinedQuery = {
      where: {},
      pagination: {}
    };

    return dispatch({
      type: ActionTypes.fetchPlural('port'),
      payload: payloadCollection(collection, PayloadStates.FETCHING, null, combinedQuery),
      query: combinedQuery
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/port/test.js